import { gql } from "@apollo/client";

export const GET_IMPRIMIR_VISITAS = gql`
    query GetImpresionVisitas($filter: ImprimirVisitaFilterInput!) {
    impresionVisitas(filter: $filter) {
        success
        error
        valorEsperado {
            idVisita
            idTipoVisita
            tipoVisita
            idPaciente
            paciente
            edad
            idProfesional
            profesional
            idEvaluacion
            idTipoModulo
            programa
            cobertura
            idTipoDocumento
            tipoDocumento
            fecha
            estadoCoordinacion
            }
        }
    }
`;

export const adaptImprimirVisitas = (visita) => {
  return {
    idVisita: visita?.idVisita,
    idTipoVisita: visita?.idTipoVisita,
    tipoVisita: visita?.tipoVisita,
    idPaciente: visita?.idPaciente,
    paciente: visita?.paciente,
    edad: visita?.edad,
    idProfesional: visita?.idProfesional,
    profesional: visita?.profesional,
    idEvaluacion: visita?.idEvaluacion,
    idTipoModulo: visita?.idTipoModulo,
    programa: visita?.programa,
    cobertura: visita?.cobertura,
    idTipoDocumento: visita?.idTipoDocumento,
    tipoDocumento: visita?.tipoDocumento,
    fecha: visita?.fecha,
    estadoCoordinacion: visita?.estadoCoordinacion
  };
};

export const adaptImprimirVisitasArray = (visitas) => {
  return structuredClone(visitas)?.
  map((visita) => adaptImprimirVisitas(visita));
};